// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".helpdesk__footer[data-v-1d7e689c]{display:flex;flex-direction:column;align-items:center;justify-content:center;padding-top:20px;padding-bottom:20px}.helpdesk__footer p[data-v-1d7e689c]{font-style:normal;font-weight:500;font-size:18px;line-height:24px}.helpdesk__footer__actions[data-v-1d7e689c]{margin-top:20px;display:flex;flex-direction:row;align-items:center;justify-content:center;gap:10px}", ""]);
// Exports
module.exports = exports;
